<div
    #zoomGalleryContainer
    [attr.role]="'tablist'"
    #zoomImageContainer
    class="zoom-image-gallery-container"
    [ngClass]="{
        'image-gallery-vertical': orientation === 'vertical',
        'image-gallery-horizontal': orientation === 'horizontal'
    }"
    [ngStyle]="{ height: numberImagesOutOfViewPort > 0 ? '100vh' : 'auto' }"
    [attr.aria-labelledby]="prefixTab + '-image-gallery'"
    [attr.aria-orientation]="orientation">
    @if (numberImagesOutOfViewPort > 0) {
    <button
        id="top-arrow-icon"
        class="arrow-icon"
        [ngClass]="{ disabled: numberImagesOutOfViewPortFromTop === 0 }"
        [disabled]="numberImagesOutOfViewPortFromTop === 0"
        (click)="scrollTop()"
        tabindex="-1">
        <svg:svg
            class="toggler-icon"
            style="transform: rotate(180deg)"
            viewBox="0 0 24 24"
            [attr.width]="'15px'"
            focusable="false"
            [attr.aria-hidden]="'true'">
            <svg:path
                d="M 3,9 12,18 21,9"
                stroke="black"
                stroke-width="3"
                fill="none"
                [attr.stroke-linecap]="'round'" />
        </svg:svg>
    </button>
    }

    <div
        #galleryContainer
        class="zoom-image-gallery"
        [ngStyle]="{ 'justify-content': numberImagesOutOfViewPort > 0 ? 'flex-start' : 'center' }">
        <div
            class="gallery-container"
            [ngClass]="{
                'image-gallery-vertical': orientation === 'vertical',
                'image-gallery-horizontal': orientation === 'horizontal'
            }"
            [ngStyle]="{ transform: getCurrentTranslateYString() }">
            @for (image of assets; track trackByUrl(idx, image); let idx = $index) {

            <button
                #thumbnail
                [ngClass]="{
                    'gallery-item-vertical': orientation === 'vertical',
                    'gallery-item-horizontal': orientation === 'horizontal'
                }"
                [attr.role]="'tab'"
                tabindex="{{ idx === currentIndex ? 0 : -1 }}"
                [attr.aria-selected]="idx === currentIndex"
                [attr.aria-controls]="prefixerAriaControls(idx)"
                id="{{ prefixTab }}{{ idx }}"
                class="image-gallery-item"
                (click)="handleThumbnailSelectedWithClick(idx)"
                (keyup)="handleThumbnailSelectedWithKey($event, idx)">
                <!-- in the case of beltkits we format the urls with beltkitSeoImgSrc -->
                @if ( product.templateType === productTemplateType.Beltkit || product.templateType ===
                productTemplateType.DoubleFragrance) {

                <img
                    class="gallery-img"
                    hI18nAsset
                    [tag]="image.tag"
                    [hI18nAttr]="'alt'"
                    [imageTitle]="product.title"
                    [url]="image.url"
                    [ngClass]="{ checked: idx === currentIndex }"
                    alt=""
                    [attr.srcset]="
                                image.url
                                    | productImageSeoUrl
                                        : {
                                              slug: product.slug,
                                              imageSize: thumbnailSize,
                                              srcSet: true,
                                              templateType: product.templateType,
                                          }
                            "
                    [attr.src]="
                                image.url
                                    | productImageSeoUrl
                                        : {
                                              slug: product.slug,
                                              imageSize: thumbnailSize,
                                              templateType: product.templateType,
                                          }
                            " />

                } @else { @if (image.source === assetPlatforme) {

                <img
                    class="gallery-img"
                    hI18nAsset
                    [hI18nAttr]="'alt'"
                    [imageTitle]="product.title"
                    [url]="image.url"
                    [tag]="image.tag"
                    [ngClass]="{ checked: idx === currentIndex }"
                    [attr.srcset]="image.url | persoImgSrc : thumbnailSize"
                    [attr.src]="image.url | persoImgSrc : thumbnailSize"
                    alt="" />

                } @else {

                <img
                    class="gallery-img"
                    hI18nAsset
                    [tag]="image.tag"
                    [url]="image.url"
                    [hI18nAttr]="'alt'"
                    [imageTitle]="product.title"
                    [ngClass]="{ checked: idx === currentIndex }"
                    [attr.srcset]="
                                image.url
                                    | productImageSeoUrl
                                        : {
                                              slug: product.slug,
                                              imageSize: thumbnailSize,
                                              srcSet: true,
                                              templateType: product.templateType,
                                          }
                            "
                    [attr.src]="
                                image.url
                                    | productImageSeoUrl
                                        : {
                                              slug: product.slug,
                                              imageSize: thumbnailSize,
                                              templateType: product.templateType,
                                          }
                            "
                    alt="" />

                } }
            </button>

            }
        </div>
    </div>

    @if (numberImagesOutOfViewPort > 0) {
    <button
        id="bottom-arrow-icon"
        class="arrow-icon"
        [ngClass]="{ disabled: numberImagesOutOfViewPortFromBottom === 0 }"
        [disabled]="numberImagesOutOfViewPortFromBottom === 0"
        (click)="scrollBottom()"
        tabindex="-1">
        <svg:svg
            class="toggler-icon"
            viewBox="0 0 24 24"
            [attr.width]="'15px'"
            focusable="false"
            [attr.aria-hidden]="'true'">
            <svg:path
                d="M 3,9 12,18 21,9"
                stroke="black"
                stroke-width="3"
                fill="none"
                [attr.stroke-linecap]="'round'" />
        </svg:svg>
    </button>
    }
</div>
